import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './style';
import BrandingLink from './components/BrandingLink';

const CustomBranding = ({ branding, backgroundIsMedia, withProgressBar }) => {
  return (
    <Container
      data-testid="CustomBranding/Container"
      data-css-selector="custom branding container"
      backgroundIsMedia={backgroundIsMedia}
      withProgressBar={withProgressBar}
    >
      <BrandingLink {...branding} />
    </Container>
  );
};

CustomBranding.propTypes = {
  branding: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string.isRequired,
    schemalessUrl: PropTypes.string,
    logoUrl: PropTypes.string,
  }),
  backgroundIsMedia: PropTypes.bool,
  withProgressBar: PropTypes.bool,
};

export default CustomBranding;
